import { render, staticRenderFns } from "./RipaAdminTemplate.vue?vue&type=template&id=a38c14cc"
import script from "./RipaAdminTemplate.vue?vue&type=script&lang=js"
export * from "./RipaAdminTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports